import { Group, PinInput, PinInputProps, Text } from '@mantine/core'

export const Pinput = (props: PinInputProps) => (
  <Group justify="center">
    <Text fw="bold">Verification Code</Text>
    <PinInput oneTimeCode aria-label="One time code" length={6} {...props} />
  </Group>
)
